<script>
	// Components
	import Icon from '@/Components/Icon.svelte';
	import { createEventDispatcher } from 'svelte';
	import FontIcon from '@/Components/FontIcon.svelte';

	const dispatch = createEventDispatcher();

	export let meeting;
	export let order;
	export let last;
	export let active;

	function shiftOrderUp() {
		dispatch('up');
	}

	function shiftOrderDown() {
		dispatch('down');
	}
	function triggerMeetingSort() {
		dispatch('sort');
	}
</script>

<div class="p-1 border rounded" class:bg-primary={active} class:text-white={active} class:bg-white={!active}>
	<div class="flex flex-row">
		<div class="flex-1">
			<div class="flex space-x-2 w-full my-0.5">
				<div class="flex flex-row items-center justify-center space-x-1">
					<button on:click={() => shiftOrderUp()} disabled={order === 0} class:opacity-0={order === 0}>
						<Icon name="up-arrow" classes="w-5 h-5" />
					</button>
					<input
						type="number"
						min="0"
						bind:value={meeting.order}
						class="border w-8"
						on:blur={() => triggerMeetingSort()}
					/>
					<button disabled={order === last} class:opacity-0={order === last} on:click={() => shiftOrderDown()}>
						<Icon name="down-arrow" classes="w-5 h-5" />
					</button>
				</div>
				<div class="flex justify-center items-center text-xl w-full border-l">
					<div class="flex flex-row w-full ml-3">
						<div class="flex flex-col">
							<FontIcon icon={meeting.race_type.name.toLowerCase()} />
						</div>
						<div class="flex flex-row items-center justify-between w-full flex-grow">
							<h1 class="ml-2">
								{meeting.name}
							</h1>
							<h1 class="ml-2">
								({meeting.country})
							</h1>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
